import Toggle from '@atlaskit/toggle';
import Tooltip from '@atlaskit/tooltip';
import { AfInfoIcon } from '@fuegokit/fuegoicons-react';
import { Box } from '@fuegokit/react';
import { FuegoSystemStyleObject } from '@fuegokit/react/lib/sx';
import React from 'react';

interface SwitchElementProps {
  label: string;
  value: boolean;
  onToggle: () => void;
  id: string;
  labelStyles?: FuegoSystemStyleObject;
  isDisabled?: boolean;
  explanation?: string;
}

export function SwitchElement({
  label,
  value,
  onToggle,
  id,
  labelStyles,
  isDisabled,
  explanation,
}: Readonly<SwitchElementProps>) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
      }}
    >
      <Toggle
        id={id}
        size="regular"
        isChecked={value}
        onChange={onToggle}
        isDisabled={isDisabled}
      />
      <Box
        as="label"
        htmlFor={id}
        sx={{
          paddingLeft: 1,
          color: 'text.default',
          ...labelStyles,
        }}
      >
        {label}
      </Box>
      {explanation ? (
        <Tooltip content={explanation}>
          <AfInfoIcon size={'small'} />
        </Tooltip>
      ) : null}
    </Box>
  );
}
